
const preferences = {
    /*address: 'http://meteo.athene.SNL'*/
    address: 'https://meteo.laimburg.it/'
}

export {preferences};